import React from 'react';

import css from './glow-circle.module.scss';

interface Props {
  ref: React.Ref<HTMLDivElement | null>;
}
export const GlowCircle: React.FC<Props> = ({ ref }) => {
  // @ts-ignore
  return <div className={css.glowCircle} ref={ref} />;
};
